<!-- Template for dialogService -->
<div class="modal-header">
  <h4>{{ teacher.displayName }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <img *ngIf="teacher.profilePictureName"
    [style]="{ 'width': getProfilePictureWidth(teacher), 'height': getProfilePictureHeight(teacher) }"
    class="profile-picture"
    src="../data/public/organization/{{ teacher.organizationId }}/teacher/{{ teacher.id }}/{{ teacher.profilePictureName }}"
    alt="profile picture" />

  <span [innerHtml]="teacher.profileText"></span>
  <!--
  <div class="courseSelector-addToFilterPanel">
    <span class="courseSelector-popup-checkbox">
      <span class="fa fa-{{ teacher.isSelected(teacher.id) ? 'check-' : '' }}square-o"></span>
      <a data-ng-click="courseModel.filter.teacher.toggle(teacher.id)">
        {{ 'courseSelector_selectThisTeacher' | l10n }}
      </a>
    </span>
  </div>
  -->
</div>
